import React from 'react';
import { useStyles } from 'yoshi-flow-editor-runtime/tpa-settings/react';
import { useStylesParams } from '../../../../../hooks';
import { st, classes } from './PlanName.st.css';

interface Props {
  name: string;
  highlighted: boolean;
}

export const PlanName: React.FC<Props> = ({ name, highlighted }) => {
  const stylesParams = useStylesParams();
  const styles = useStyles();
  const showPlanName = styles.get(stylesParams.showPlanName);

  if (!showPlanName) {
    return null;
  }

  return (
    <h2 aria-describedby={highlighted ? 'ribbon' : undefined} className={st(classes.planTitle, { highlighted })}>
      {name}
    </h2>
  );
};
